import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './CirclesAnnouncement.scss';

const CirclesAnnouncement = props => {
  const subtitle = 'Your storefront just got a major upgrade—your links are now easier for shoppers to find, with no extra work on your part.';
  const steps = [
    {
      title: 'Search, Wishlists & Circles',
      description: 'Shoppers can now search your storefront, save favorites to wishlists, and add you to their shopping circles—all in one place.'
    },
    {
      title: 'Latest Finds',
      description: (
        <>
          This tab automatically shows all visible collection links plus your quick links. You can adjust visibility anytime in your{' '}
          <Link to='/settings?tab=Shop+Settings'>account settings</Link>.
        </>
      )
    },
    {
      title: 'Most Popular',
      description: 'Highlights your top-performing products from the past 30 days based on shopper engagement.'
    }
  ];
  return (
    <div className='circles-announcement-outer-container'>
      <div className='main-panel'>
        <div className='header'>
          <div className='badge'>New Feature Alert</div>
          <div className='title'>
            Introducing your new
            <br />
            storefront
          </div>
          <div className='subtitle'>{subtitle}</div>
        </div>
        <div className='steps'>
          {steps.map((step, index) => (
            <div className='step' key={index}>
              <div className='number'>{index + 1}</div>
              <div className='content'>
                <div className='title'>{step.title}</div>
                <div className='description'>{step.description}</div>
              </div>
            </div>
          ))}
        </div>
        <div className='actions'>
          <div onClick={() => props.closeModal()} className='action'>
            View My New Shop
          </div>
        </div>
      </div>
    </div>
  );
};

CirclesAnnouncement.propTypes = {
  user: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  extra: PropTypes.shape({}).isRequired
};

export default CirclesAnnouncement;
